import React, {useRef, useState} from 'react';
import PropTypes from 'prop-types';
import {PageHeader} from 'antd';
import Line from '@ant-design/charts/es/line';

import DateRange from '../component/DateRange';
import {getRangeReports} from '@/api/report';
import ChartDownloader from '@/page/app/ReportPage/component/ChartDownloader';

LineChart.propTypes = {
    appId: PropTypes.string.isRequired,
    alias: PropTypes.string.isRequired,
};

function LineChart({appId, alias}) {
    const chartRef = useRef();
    const [lineData, setLineData] = useState([]);

    async function onChange(dates, dateStrings) {
        // console.log(dates, dateStrings);
        const {data = []} = await getRangeReports(alias, appId, dateStrings[0], dateStrings[1]);
        // console.log(data);

        const newData = data.reduce((accumulator, currentValue) => {
            const {
                reportDate,
                appEnterUserCount,
                appEnterCount,
                userMsgUserCount,
                userMsgCount,
            } = currentValue;

            accumulator.push({
                category: '进入应用（人）',
                date: reportDate,
                value: appEnterUserCount,
            });
            accumulator.push({
                category: '进入应用（次）',
                date: reportDate,
                value: appEnterCount,
            });
            accumulator.push({
                category: '用户消息（人）',
                date: reportDate,
                value: userMsgUserCount,
            });
            accumulator.push({
                category: '用户消息（次）',
                date: reportDate,
                value: userMsgCount,
            });

            return accumulator;
        }, []);
        setLineData(newData);
    }

    return (
        <>
            <PageHeader
                title="趋势图"
                style={{padding: '16px 0'}}
                extra={
                    <DateRange onChange={onChange}>
                        <ChartDownloader chartRef={chartRef} name="成员活跃度趋势图.png" />
                    </DateRange>
                }
            />
            <Line
                data={lineData}
                chartRef={chartRef}
                padding="auto"
                xField="date"
                yField="value"
                seriesField="category"
                smooth
                // color={['#3571ff', '#fb104a', '#29cc97']}
                point={{shape: 'circle'}}
            />
        </>
    );
}

export default LineChart;
